import {TimeSpan} from "@sparkware/app-utils";

import Store from "../../../utils/store";
import GenericRealityCheckMessageHandler from "./generic_reality_check_message_handler";
import {IElasticEventData} from "../../../../../common/interfaces/structured-logging-service-interface";

export default class RealityCheckWithConfirmationMessageHandler extends GenericRealityCheckMessageHandler {
    static CLASS = 'RealityCheckWithConfirmationMessageHandler';

    private _awaitsRealityCheckConfirmation: boolean = false;

    protected set _lastRealityCheckMessageIndexShown(value) {
        try {
            Store.set("lastRealityCheckMessageIndexShown", value);
        }
        catch (err) {
            const data: IElasticEventData = {
                CGPEventCategory: 'RealityCheck',
                CGPEventAction: 'set lastRealityCheckMessageIndexShown error',
                CGPEventLabel:err.toString(),
                CGPEventValue: value.toString()
            };
            this._initParams.serviceFactory.structuredLoggingService().getLogger(data).info();
        }
    }

    protected get _lastRealityCheckMessageIndexShown() {
        let lsValue = Store.get("lastRealityCheckMessageIndexShown");
        let val = parseInt(lsValue ?? 0);
        if(isNaN(val)){
            const data: IElasticEventData = {
                CGPEventCategory: 'RealityCheck',
                CGPEventAction: 'get _lastRealityCheckMessageIndexShown is NaN',
                CGPEventValue: lsValue.toString()
            };
            this._initParams.serviceFactory.structuredLoggingService().getLogger(data).info();
        }
        return val;
    }

    private set _lastConfirmedRealityCheckMessageIndex(value) {
        try {
            Store.set("lastRealityCheckMessageIndexConfirmed", value);
        }
        catch (err) {
            const data: IElasticEventData = {
                CGPEventCategory: 'RealityCheck',
                CGPEventAction: 'set lastRealityCheckMessageIndexConfirmed error',
                CGPEventLabel:err.toString(),
                CGPEventValue: value.toString()
            };
            this._initParams.serviceFactory.structuredLoggingService().getLogger(data).info();
        }
    }

    private get _lastConfirmedRealityCheckMessageIndex() {
        let lsValue = Store.get("lastRealityCheckMessageIndexConfirmed");
        let val = parseInt(lsValue ?? 0)
        if(isNaN(val)){
            const data: IElasticEventData = {
                CGPEventCategory: 'RealityCheck',
                CGPEventAction: 'get _lastConfirmedRealityCheckMessageIndex is NaN',
                CGPEventValue: lsValue.toString()
            };
            this._initParams.serviceFactory.structuredLoggingService().getLogger(data).info();
        }
        return val;
    }

    _realityCheckConfirmed(){
        this._awaitsRealityCheckConfirmation = false;
        this._lastConfirmedRealityCheckMessageIndex = this._lastRealityCheckMessageIndexShown;
    }

    protected _onSessionTimerUpdate(eventData: {sessionTime: TimeSpan}): void {
        try {
            if (!this._initParams.serviceFactory.oAuth2Service().isAuthorized()) {
                return;
            }

            let currentRealityCheckMessageIndexToBeShown = Math.floor(eventData.sessionTime.totalMilliseconds / this._initParams.realityCheckInterval.totalMilliseconds);

            const indexNotShown = (currentRealityCheckMessageIndexToBeShown && (currentRealityCheckMessageIndexToBeShown !== this._lastRealityCheckMessageIndexShown));
            const indexNotConfirmed = (currentRealityCheckMessageIndexToBeShown > this._lastConfirmedRealityCheckMessageIndex);

            if (indexNotShown || (indexNotConfirmed && !this._awaitsRealityCheckConfirmation)) {
                this._initParams.handleRealityCheckMessageCallback(eventData.sessionTime, this._realityCheckConfirmed.bind(this));
                this._awaitsRealityCheckConfirmation = true;
                this._lastRealityCheckMessageIndexShown = currentRealityCheckMessageIndexToBeShown;
            }
        }catch (err) {
            const data: IElasticEventData = {
                CGPEventCategory: 'RealityCheck',
                CGPEventAction: 'onSessionTimerUpdate error',
                CGPEventLabel:err.toString(),
                CGPEventValue : 'lastRealityCheckMessageIndexShown: '+this._lastRealityCheckMessageIndexShown + ', lastConfirmedRealityCheckMessageIndex: '+this._lastConfirmedRealityCheckMessageIndex
            };
            this._initParams.serviceFactory.structuredLoggingService().getLogger(data).info();
        }
    }
}